import { UseFormReturn } from "react-hook-form";
import SearchAddressForm from "@shared/components/application/form/search-address/SearchAddressForm/SearchAddressForm.web";
import { useEffect } from "react";
import { useTranslation } from "@shared/utils/internationalization";
import { AddressType } from "@shared/components/application/form/search-address/SearchAddressForm/SearchAddressForm.props";

export const FORM_ID = "checkout_billing_address_form";

export default function CheckoutBillingAddressForm({
  form,
  id = FORM_ID,
  isRequired = true,
  label,
  onValidFields,
  onInvalidFields,
  onBillingAddressChange,
}: {
  form: UseFormReturn;
  id?: string;
  isRequired?: boolean;
  label?: string;
  onValidFields?: () => void;
  onInvalidFields?: () => void;
  onBillingAddressChange?: (billingAddress: AddressType) => void;
}): JSX.Element {
  const { t } = useTranslation("common");
  const displayLabel = label ?? t("Billing address");

  useEffect(() => {
    if (form.formState.isValid) {
      onValidFields?.();
    } else {
      onInvalidFields?.();
    }
  }, [form.formState.isValid]);

  return (
    <form data-testid={id} id={id} onSubmit={(e) => e.preventDefault()}>
      <SearchAddressForm
        searchAriaLabel={displayLabel}
        label={displayLabel}
        form={form}
        formId={id}
        isRequired={isRequired}
        titleProps={{
          fontWeight: 700,
          marginBottom: "2xs",
        }}
        updateAddressCallback={onBillingAddressChange}
      />
    </form>
  );
}
